module.exports = __webpack_public_path__ + "img/Cayman Islands.c030bdb5.svg";